import React, {useState, useEffect} from 'react'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import authFetch from '../../../../lib/authFetch';


export default function unrecModal(props) {
    function handleAction() {
        //unreconcile the sale
        authFetch("/sale/" + props.saleID + "/unreconcile", {method: "PUT"})
        .then(r => {
            //and let the parent know we had some action
            props.onAction()            
        })
    }

    return(
        <Dialog open={props.open} maxWidth="xs" fullWidth={true} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">
                Unreconcile this transaction?
            </DialogTitle>
            <DialogContent>
                <p>Are you sure you want to unreconcile this transaction?</p>
            </DialogContent>
            <DialogActions>
                <Button color="default" onClick={props.onCancel} variant="contained">
                    Cancel
                </Button>
                <Button color="secondary" onClick={handleAction} variant="contained">
                    Unreconcile
                </Button>
            </DialogActions>
      </Dialog>
    )
}